var _desc, _defs, _g, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 400,
    viewBox: "15 15 150 150",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 90 90)",
    id: "137800a1-51f2-44cc-8a9d-c521de23c764"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -90,
    y: -90,
    rx: 0,
    ry: 0,
    width: 180,
    height: 180
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(Infinity NaN NaN Infinity 0 0)",
    id: "8841735a-2a80-4ff6-bac8-9e4225cecf90"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.77 0 0 3.77 90 90)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33 0 0 -1.33 0 -13.05)",
    id: "path20",
    clipPath: "url(#CLIPPATH_3)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_3"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 0.04 -9.38) translate(-420.94, -297.64)",
    id: "path14",
    d: "M 0 595.276 L 841.89 595.276 L 841.89 0 L 0 0 Z",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(229,22,94)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(4.38, 0)",
    d: "M 0 0 C 0 -2.417 -1.959 -4.375 -4.375 -4.375 C -6.792 -4.375 -8.75 -2.417 -8.75 0 C -8.75 2.416 -6.792 4.375 -4.375 4.375 C -1.959 4.375 0 2.416 0 0",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33 0 0 -1.33 0 0.02)",
    id: "path24",
    clipPath: "url(#CLIPPATH_4)"
  }, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_4"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 0.04 0.43) translate(-420.94, -297.64)",
    id: "path14",
    d: "M 0 595.276 L 841.89 595.276 L 841.89 0 L 0 0 Z",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(229,22,94)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(4.38, 0)",
    d: "M 0 0 C 0 -2.416 -1.959 -4.375 -4.375 -4.375 C -6.792 -4.375 -8.75 -2.416 -8.75 0 C -8.75 2.416 -6.792 4.375 -4.375 4.375 C -1.959 4.375 0 2.416 0 0",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33 0 0 -1.33 -13.04 0.02)",
    id: "path28",
    clipPath: "url(#CLIPPATH_5)"
  }, _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_5"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 9.81 0.43) translate(-420.94, -297.64)",
    id: "path14",
    d: "M 0 595.276 L 841.89 595.276 L 841.89 0 L 0 0 Z",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(46,41,91)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(4.38, 0)",
    d: "M 0 0 C 0 -2.416 -1.958 -4.375 -4.375 -4.375 C -6.791 -4.375 -8.75 -2.416 -8.75 0 C -8.75 2.416 -6.791 4.375 -4.375 4.375 C -1.958 4.375 0 2.416 0 0",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33 0 0 -1.33 0 13.05)",
    id: "path32",
    clipPath: "url(#CLIPPATH_6)"
  }, _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_6"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 0.04 10.2) translate(-420.94, -297.64)",
    id: "path14",
    d: "M 0 595.276 L 841.89 595.276 L 841.89 0 L 0 0 Z",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(229,22,94)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(4.38, 0)",
    d: "M 0 0 C 0 -2.416 -1.959 -4.375 -4.375 -4.375 C -6.792 -4.375 -8.75 -2.416 -8.75 0 C -8.75 2.416 -6.792 4.375 -4.375 4.375 C -1.959 4.375 0 2.416 0 0",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33 0 0 -1.33 13.04 13.05)",
    id: "path36",
    clipPath: "url(#CLIPPATH_7)"
  }, _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_7"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 -9.74 10.2) translate(-420.94, -297.64)",
    id: "path14",
    d: "M 0 595.276 L 841.89 595.276 L 841.89 0 L 0 0 Z",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(46,41,91)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(4.38, 0)",
    d: "M 0 0 C 0 -2.416 -1.959 -4.375 -4.375 -4.375 C -6.791 -4.375 -8.75 -2.416 -8.75 0 C -8.75 2.416 -6.791 4.375 -4.375 4.375 C -1.959 4.375 0 2.416 0 0",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33 0 0 -1.33 -13.04 -13.02)",
    id: "path40",
    clipPath: "url(#CLIPPATH_8)"
  }, _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_8"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 9.81 -9.35) translate(-420.94, -297.64)",
    id: "path14",
    d: "M 0 595.276 L 841.89 595.276 L 841.89 0 L 0 0 Z",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(46,41,91)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(3.24, -4.38)",
    d: "M 0 0 L -6.481 0 C -7.108 0 -7.616 0.508 -7.616 1.134 L -7.616 7.615 C -7.616 8.242 -7.108 8.75 -6.481 8.75 L 0 8.75 C 0.626 8.75 1.134 8.242 1.134 7.615 L 1.134 1.134 C 1.134 0.508 0.626 0 0 0",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33 0 0 -1.33 -13.04 13.05)",
    id: "path44",
    clipPath: "url(#CLIPPATH_9)"
  }, _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_9"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 9.81 10.2) translate(-420.94, -297.64)",
    id: "path14",
    d: "M 0 595.276 L 841.89 595.276 L 841.89 0 L 0 0 Z",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(46,41,91)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(3.24, -4.38)",
    d: "M 0 0 L -6.481 0 C -7.108 0 -7.616 0.508 -7.616 1.135 L -7.616 7.616 C -7.616 8.241999999999999 -7.108 8.75 -6.481 8.75 L 0 8.75 C 0.626 8.75 1.134 8.242 1.134 7.616 L 1.134 1.135 C 1.134 0.508 0.626 0 0 0",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33 0 0 -1.33 13.04 -13.02)",
    id: "path48",
    clipPath: "url(#CLIPPATH_10)"
  }, _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_10"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 -9.74 -9.35) translate(-420.94, -297.64)",
    id: "path14",
    d: "M 0 595.276 L 841.89 595.276 L 841.89 0 L 0 0 Z",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(46,41,91)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(3.24, -4.38)",
    d: "M 0 0 L -6.482 0 C -7.1080000000000005 0 -7.616 0.508 -7.616 1.134 L -7.616 7.615 C -7.616 8.242 -7.108 8.75 -6.481999999999999 8.75 L 0 8.75 C 0.626 8.75 1.134 8.242 1.134 7.615 L 1.134 1.134 C 1.134 0.508 0.626 0 0 0",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33 0 0 -1.33 13.04 0.02)",
    id: "path52",
    clipPath: "url(#CLIPPATH_11)"
  }, _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_11"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 -9.74 0.43) translate(-420.94, -297.64)",
    id: "path14",
    d: "M 0 595.276 L 841.89 595.276 L 841.89 0 L 0 0 Z",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(46,41,91)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(3.24, -4.38)",
    d: "M 0 0 L -6.482 0 C -7.1080000000000005 0 -7.616 0.508 -7.616 1.135 L -7.616 7.616 C -7.616 8.241999999999999 -7.108 8.75 -6.481999999999999 8.75 L 0 8.75 C 0.626 8.75 1.134 8.242 1.134 7.616 L 1.134 1.135 C 1.134 0.508 0.626 0 0 0",
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbol);
export default __webpack_public_path__ + "static/media/symbol.44cf9fde1310189798952c90f2de574e.svg";
export { ForwardRef as ReactComponent };